import socket from '../socketConfig'
import { userStore } from '@/store/user'

const CONTEXT = 'company'

const companyHandler = {
  setupEventListeners(): void {
    socket.on(`${CONTEXT}:planUpdated`, async (data: any) => {
      const userState = userStore()
      
      // Atualizar informações do usuário para refletir as novas permissões
      try {
        await userState.updateUserInfo()
      } catch (error) {
        console.error('❌ [companyHandler] Erro ao atualizar user info após mudança de plano:', error)
      }
    })
  },

  removeEventListeners(): void {
    socket.off(`${CONTEXT}:planUpdated`)
  }
}

export default companyHandler

